<template>
  <div id="bottom-bar">
    <div id="header" class="bg-white shadow-sm" style="z-index: 9;" :class="{'mb-0': home}">
      <div class="container-fluid py-2 px-3 px-md-4" :class="{'d-none d-md-block': home}">
        <div class="row justify-content-between align-items-center">
          <div class="col-6">
            <router-link :to="url + '/home'" class="text-dark text-decoration-none text-nowrap" aria-label="Acessar home da aplicação" v-if="origin === '8'">
              <div class="d-flex align-items-center">
                <i class="fa fa-chevron-left mr-2"></i>
                <h2 class="h6 m-0 py-3">Voltar</h2>
              </div>
            </router-link>
            <router-link :to="url + '/home'" class="text-dark text-decoration-none text-nowrap" aria-label="Acessar home da aplicação" v-else>
              <img :src="base_assets + '/logo.png'" :alt="empresa.nome_fantasia" style="width: auto; height: 52px" v-if="origin === '1'">
              <div class="d-flex" v-else>
                <img :src="empresa.url_imagem" :alt="empresa.nome_fantasia" class="logo-header" v-if="empresa.url_imagem">
                <h2 class="font-weight-bold h6 m-0 py-3 limite-1 d-none d-lg-block">{{empresa.nome_fantasia}}</h2>
              </div>
            </router-link>
          </div>
          <div class="col-6 d-flex justify-content-end align-items-center" v-if="origin === '8'">
            <a href="#" class="icone-desktop text-primary not-decoration mr-2" role="listitem" aria-label="Chamar garçom" @click.prevent="chamarGarcom()">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M23 21H13v-2h7.343A2.66 2.66 0 0 0 23 16.343c0-5.88-4.371-10.79-10-11.298V3h1a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2h1v2.044c-5.629.509-10 5.418-10 11.299A2.66 2.66 0 0 0 3.657 19H11v2H1a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2"/></svg>
              </div>
              <span class="icone-text d-block">Chamar garçom</span>
            </a>
            <router-link to="/fechar-conta" class="btn btn-primary" style="position: relative"role="listitem" aria-label="Fechar conta">
              Fechar conta
            </router-link>
          </div>
          <div class="col-6 d-flex justify-content-end align-items-center" v-else-if="!modo_catalogo">
            <router-link :to="url + '/pedidos'" class="icone-desktop not-decoration" active-class="active" style="position: relative" role="listitem" aria-label="Pedidos">
              <div aria-hidden="true"><icon name="pedido" size="18" :full="$route.name === 'Pedidos'"></icon><span class="n-pedidos n-desktop" v-show="qtdPedido > 0">{{qtdPedido}}</span></div>
              <span class="icone-text">Pedidos</span>
            </router-link>
            <router-link :to="url + '/promocoes'" class="icone-desktop not-decoration" active-class="active" role="listitem" aria-label="Promoções">
              <div aria-hidden="true"><icon name="cupom" size="18" :full="$route.name === 'Promocoes'"></icon></div>
              <span class="icone-text">Promoções</span>
            </router-link>
            <router-link :to="url + '/info'" class="icone-desktop not-decoration" active-class="active" role="listitem" aria-label="Quem somos">
              <div aria-hidden="true"><icon name="information" size="18" :full="$route.name === 'InfoRestaurante'"></icon></div>
              <span class="icone-text">Empresa</span>
            </router-link>
            <card-franquia v-if="franquiasEnabled" class="ml-2 mr-2 mr-md-0"/>
            <router-link :to="url + '/perfil'" class="icone-desktop not-decoration" active-class="active" role="listitem" aria-label="Perfil" title="Perfil" v-if="usuario.id_cliente">
              <div aria-hidden="true"><icon name="perfil" size="20" :full="$route.name === 'Perfil'"></icon></div>
            </router-link>
            <router-link :to="url + '/perfil'" class="btn btn-primary text-nowrap ml-3 d-none d-md-inline-block" role="listitem" aria-label="Meu Perfil" v-if="!usuario.id_cliente && !zap && !qtdSacola">
              Entrar ou cadastrar
            </router-link>
            <router-link :to="url + '/sacola'" class="btn btn-primary ml-3 d-none d-md-inline-flex" role="listitem" aria-label="Sacola" v-else>
              <icon name="sacola" size="22" full="true"></icon><span class="text-white ml-1 font-weight-bolder" v-show="qtdSacola > 0">{{qtdSacola}}</span>
            </router-link>
            <a href="javascript:" class="btn d-md-none mr-1" role="listitem" aria-label="Pesquisar" v-if="origin === '1' && !franquiasEnabled && $route.name !== 'Categorias'" @click="pesquisar()">
              <div aria-hidden="true"><icon name="search" size="24"></icon></div>
            </a>
            <router-link :to="url + '/promocoes'" class="btn btn-sm ml-2 d-md-none" role="listitem" aria-label="Promoções" active-class="active" v-if="zap">
              <div aria-hidden="true"><icon name="cupom" size="24" :full="$route.name === 'Promocoes'"></icon></div>
            </router-link>
            <router-link :to="url + '/info'" class="btn btn-sm ml-1 d-md-none" role="listitem" aria-label="Info" active-class="active">
              <div aria-hidden="true"><icon name="information" size="20" :full="$route.name === 'InfoRestaurante'"></icon></div>
            </router-link>
            <router-link :to="url + '/perfil'" class="btn btn-sm ml-1 d-md-none" role="listitem" aria-label="Info" active-class="active" v-if="zap && usuario.id_cliente">
              <div aria-hidden="true"><icon name="perfil" size="24" :full="$route.name === 'Perfil'"></icon></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <c-sacola @close="openSacola = false" :opened="openSacola"/>

    <div class="text-center fixed-bottom d-md-none" style="z-index: 9" v-show="!hideBotton && !modo_catalogo" v-if="origin !== 3">
      <div class="bottom-bar shadow-top position-relative" :class="{'lecard-go': origin === '5'}" style="border-radius: 24px 24px 0 0" role="navigation">
        <div class="container">
          <div class="row align-items-center" role="list">
            <router-link :to="url + '/home'" active-class="active" class="col icone-bar not-decoration" role="listitem" aria-label="Home">
              <div aria-hidden="true">
                <icon name="home" size="21" :full="$route.name === 'Home'"></icon>
                <span class="icone-text">Início</span>
              </div>
            </router-link>
            <router-link :to="url + '/pedidos'" active-class="active" class="col icone-bar not-decoration" style="position: relative" role="listitem" aria-label="Pedidos">
              <div aria-hidden="true">
                <icon name="pedido" size="19" :full="$route.name === 'Pedidos'"></icon>
                <span class="n-pedidos" v-show="qtdPedido > 0">{{qtdPedido}}</span>
                <span class="icone-text">Pedidos</span>
              </div>
            </router-link>
            <div class="col icone-bar icon-sacola not-decoration" role="listitem" aria-label="Sacola">
              <router-link :to="`${url}/sacola`" class="btn icon text-decoration-none" :class="{'break': !qtdSacola}">
                <icon name="sacola" size="26" full="true"></icon>
                <span class="d-block font-weight-bold ml-1" v-if="qtdSacola > 0">{{ qtdSacola }}</span>
                <span class="icone-text" style="width: 100%; content: ''" v-else>Sacola</span>
              </router-link>
            </div>
            <router-link :to="url + '/promocoes'" active-class="active" class="col icone-bar not-decoration" role="listitem" aria-label="Promoção">
              <div aria-hidden="true">
                <icon name="cupom" size="22" :full="$route.name === 'Promocoes'"></icon>
                <span class="icone-text">Promoções</span>
              </div>
            </router-link>
            <router-link :to="url + '/perfil'" active-class="active" class="col icone-bar not-decoration" role="listitem" aria-label="Meu Perfil">
              <div aria-hidden="true">
                <icon name="perfil" size="22" :full="$route.name === 'Perfil'"></icon>
                <span class="icone-text">Perfil</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Icon from './Icon'
  import CSacola from "./CSacola";
  import CardFranquia from "./CardFranquia";

	export default {
	  props: ['hideBotton', 'home'],
    components: {CardFranquia, CSacola, Icon},
		data(){
			return{
				menu: false,
				fa: 'fa-ellipsis-v',
        qtdPedido: 0,
        token: localStorage.getItem('token'),
        openSacola: false,
        url: ''
			}
		},

		methods:{
      validarPedidos() {
        if (this.token && localStorage.getItem('pedidos')) {
          const qtd = parseInt(localStorage.getItem('pedidos'));
          this.qtdPedido = qtd < 10 ? qtd : 0;
        }
      },

      pesquisar() {
        if (this.$route.name === 'Categorias') {
          this.$helpers.focusrElement('search');

        } else {
          this.$router.push(this.url + '/categorias?search=true');
        }
      },

      chamarGarcom() {
        this.$helpers.chamarGarcom(this);
      }
		},

    mounted() {
      this.validarPedidos();
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
    },

    created() {
      this.$parent.$on('validarPedidos', this.validarPedidos);
      this.$parent.$on('openSacola', () => {
        this.$router.push(`${this.url}/sacola`);
      });
    },

    computed: {
      cidade() {
        return this.$store.state.cidade
      },

      qtdSacola() {
        const qtd = this.$store.state.sacola.produtos.length;
        return qtd < 10 ? qtd : 9;
      },

      empresa() {
        return this.$store.state.empresa
      },

      usuario() {
        return this.$store.state.dataUser
      },

      zap() {
        return this.$store.state.zap
      }
    }
	}
</script>

<style scoped>
.bottom-bar {
  background-color: var(--lecard-primary);
}

.icone-bar {
  padding: 14px 0;
  color: #ffffff;
}

.icone-bar.active:first-child {
  border-radius: 24px 0 0;
}

.icone-bar.active:last-child {
  border-radius: 0 24px 0 0;
}

.icone-bar .icone-text {
  margin-top: 2px;
  font-size: 0.6em;
  white-space: nowrap;
  display: block;
}

.icone-bar.active {
  background-color: rgba(0, 0, 0, 0.2);
  font-weight: 500;
}

.icone-bar .full, .icone-bar.active .line {
  display: none;
}

.icone-bar.active .full {
  display: block;
}

.icone-desktop {
  padding: 12px 10px;
  color: var(--dark);
  margin-left: 4px;
  text-align: center;
  display: none;
  align-items: baseline;
  position: relative;
}

.icone-desktop .icone-text {
  font-size: 0.9em;
  white-space: nowrap;
  margin-left: 6px;
  display: none;
}

.icone-desktop:hover {
  color: var(--lecard-primary);
}

.icone-desktop.active {
  color: var(--lecard-primary);
  font-weight: 500;
}

.icone-desktop.active::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--lecard-primary);
}

.icon-tabler {
  stroke: var(--lecard-primary);
}

.n-pedidos {
  color: #ffffff;
  position: absolute;
  left: 50%;
  top: 6px;
  transform: translateX(-50%);
  margin-left: 12px;
  background-color: var(--lecard-secondary);;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-weight: bold;
  font-size: 0.7em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.n-desktop {
  left: 18px;
  top: 4px;
  transform: none;
  margin-left: 0;
}

.icon-sacola .icon {
  margin: -46px auto -6px;
  border-radius: 50%;
  color: #fff;
  width: 80px;
  height: 80px;
  background-color: var(--lecard-secondary);
  border: 1px solid var(--lecard-secondary);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.25);
}

.icon-sacola .icon.break {
  flex-flow: row wrap;
  flex-direction: column;
}

.ios_platform .icone-bar {
  padding-bottom: 34px;
}

.bottom-bar.lecard-go .icon-sacola .icon {
  color: var(--lecard-primary);
  background-color: #ffffff;
  border: 1px solid #ffffff;
}

.bottom-bar.lecard-go .n-pedidos {
  color: var(--lecard-primary);
  background-color: #ffffff;
}

.btn.active {
  color: var(--lecard-primary)!important;
}

@media (min-width: 768px) {
  .icone-desktop {
    display: flex;
  }
}

@media (min-width: 993px) {
  .icone-desktop .icone-text {
    display: block;
  }
}
</style>
